import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const AddNoteRequestDtoSchema = z.object({
  id: z.number(),
  noteText: z.string(),
});

const AddNoteResponseDtoSchema = z.object({
  id: z.number(),
  noteText: z.string(),
  takenBy: z.string(),
  creationDate: z.coerce.date(),
});

export type AddNoteRequestDto = z.infer<typeof AddNoteRequestDtoSchema>;
export type AddNoteResponseDto = z.infer<typeof AddNoteResponseDtoSchema>;

export const addNote = (
  dto: AddNoteRequestDto,
  config?: AxiosRequestConfig<AddNoteRequestDto>
) => {
  const { id, ...data } = AddNoteRequestDtoSchema.parse(dto);

  return api
    .post(`staff/${id}/notes`, data, config)
    .then(responseContract(AddNoteResponseDtoSchema));
};
